import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { deleteBlacklistDealer, searchBlacklistDealers } from '../DealersActions';
import thumbsUpIcon from '../../assets/img/icons/thumbsup-primary.svg';

function DealerBlacklistTableRow({ item, searchParams }) {
  const { id: itemId, blockedOrganization } = item;

  const dispatch = useDispatch();
  const { id } = useParams();
  return (
    <>
      <td>{blockedOrganization?.serial ?? '-'}</td>
      <td>{blockedOrganization?.tradeName ?? '-'}</td>
      <td style={{ display: 'flex' }}>
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip${itemId}`}
          size="sm"
          type="button"
          onClick={() =>
            dispatch(
              deleteBlacklistDealer(id, blockedOrganization?.id, () =>
                dispatch(searchBlacklistDealers(searchParams, id)),
              ),
            )
          }
        >
          <img src={thumbsUpIcon} alt="Thumbs Up icon" />
        </Button>
        <UncontrolledTooltip
          className="uncontrolled-tooltip"
          delay={0}
          target={`tooltip${itemId}`}
        >
          Unblock
        </UncontrolledTooltip>
      </td>
    </>
  );
}

DealerBlacklistTableRow.propTypes = {
  searchParams: PropTypes.object.isRequired,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    blockedOrganization: PropTypes.shape({
      serial: PropTypes.string,
      tradeName: PropTypes.string,
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default DealerBlacklistTableRow;
